import { apiClient } from '~/services/api-service';
import { DownloadQrImageFormat } from '~/types/qrCode';
import { CreateQrCodeFolderPayload, QRCodeFolder, UpdateQrCodeFolderPayload } from '~/types/qrCodeFolders';

export const getQRCodeFolders = () => {
  return apiClient.get<QRCodeFolder[]>('/qrcode/folders/');
};

// export const getQRCodeFolderById = (folderId: number | string) => {
//   return apiClient.get<QRCodeFolder>(`/qrcode/folders/${folderId}/`);
// };

export const updateQRCodeFolder = ({
  folderId,
  payload,
}: {
  folderId: number | string;
  payload: UpdateQrCodeFolderPayload;
}) => {
  return apiClient.patch<QRCodeFolder>(`/qrcode/folders/${folderId}/`, payload);
};

export const createQRCodeFolder = (payload: CreateQrCodeFolderPayload) => {
  return apiClient.post<QRCodeFolder>('/qrcode/folders/', payload);
};

export const deleteQRCodeFolderById = (folderId: number | string) => {
  return apiClient.delete(`/qrcode/folders/${folderId}/`);
};

export const downloadAllQRCodesByFolderId = (folderId: number | string, imgFormat: DownloadQrImageFormat) => {
  return apiClient.get(`/qrcode/folders/${folderId}/download/`, {
    params: { img_format: imgFormat },
    responseType: 'blob',
  });
};
